const CURRENCY_CODES = Object.freeze({
  GBP: `GBP`,
  USD: `USD`,
})

export default CURRENCY_CODES
